<template>
  <svg v-if="sprite">
    <use :xlink:href="`#spr-${icon}`"></use>
  </svg>
</template>

<script>
  export default {
    props : {
      icon : {
        required : true
      },
      sprite : {
        default : true,
        required : false,
        type : Boolean
      }
    },
    data() {
      return {

      }
    }
  }
</script>
